<template>
  <v-overlay v-if="isLoadingUserRoles" z-index="10">
    <v-progress-circular indeterminate size="64" />
  </v-overlay>
  <UserDialog
    v-else
    is-open
    @close="close"
    title="Edit User"
    actionName="Save Changes"
    @submit="handleEdit"
    :userRoles="userRoles"
    :userData="user"
    :loading="isEditingUserDetails"
    editMode
  />
</template>

<script>
import UserDialog from "@/views/settings/Users/dialogs/UserDialog";
import { createNamespacedHelpers } from "vuex";
import { USERS_NAMESPACE } from "@/store/modules/users";
import {
  EDIT_USER_STAFF_DETAILS,
  FETCH_USER_ROLES
} from "@/store/modules/users/actions";
import {
  GET_IS_EDITING_USER_DETAILS,
  GET_IS_FETCHING_USER_ROLES
} from "@/store/modules/users/getters";

const { mapActions, mapGetters } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  name: "EditUserAction",
  components: { UserDialog },
  props: {
    user: Object
  },
  data() {
    return {
      isLoadingUserRoles: false,
      id: null,
      userRoles: [],
      isDialogOpen: false
    };
  },
  created() {
    this.adjustRoles();
  },
  computed: {
    ...mapGetters({
      isEditingUserDetails: GET_IS_EDITING_USER_DETAILS,
      isFetchingUserRoles: GET_IS_FETCHING_USER_ROLES
    })
  },
  methods: {
    ...mapActions({
      editUserStaffDetails: EDIT_USER_STAFF_DETAILS,
      fetchUserRoles: FETCH_USER_ROLES
    }),
    close() {
      this.$emit("close");
    },
    async adjustRoles() {
      this.isLoadingUserRoles = true;
      const { data } = await this.fetchUserRoles(this.user.id);
      this.userRoles = data.roles;
      this.isLoadingUserRoles = false;
    },
    async handleEdit(userData) {
      await this.editUserStaffDetails({ ...userData, id: this.user.id });
      this.close();
    }
  }
};
</script>

<style scoped></style>
